// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Tooltip,
//   Chip,
//   Typography,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   TablePagination,
//   CircularProgress,
//   Card,
//   CardContent,
//   Divider,
//   Stack,
// } from "@mui/material";
// import Swal from "sweetalert2";

// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import configServ from "../services/config";
// import CardHeadMenu from "../Components/Card/CardHeadMenu/CardHeadMenu";
// import { useSelector } from "react-redux";
// import OfflinePinIcon from '@mui/icons-material/OfflinePin';

// const LeaveTable = ({ handleEdit, ischange }) => {
//   const [selectedLeave, setSelectedLeave] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [leaveData, setLeaveData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const { company_id, is_admin, user_id } = useSelector(
//     (state) => state.GlobalVariables,
//   );

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [total, setTotal] = useState(0);

//   // ✅ SAFE truncate
//   const truncateText = (text, limit = 20) => {
//     if (!text) return "-";
//     return text.length > limit ? text.substring(0, limit) + "..." : text;
//   };

//   const fetchLeaveData = async (currentPage, limit) => {
//     setLoading(true);
//     try {
//       const response = await configServ.getLeaves({
//         company_id: company_id,
//         page: currentPage + 1,
//         per_page: limit,
//         isAdmin: is_admin, // ✅ FIX (small bug)
//         employee_id: user_id,
//       });

//       if (response.status === 200) {
//         setLeaveData(response.data.data || []);
//         setTotal(response.data.total || 0);
//       } else {
//         setLeaveData([]);
//         setTotal(0);
//       }
//     } catch (error) {
//       console.log(error);
//       setLeaveData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaveData(page, rowsPerPage);
//   }, [page, rowsPerPage, ischange]);

//   const handleOpen = (leave) => {
//     setSelectedLeave(leave);
//     setOpen(true);
//   };

//   // const handleEdit = (row) => {
//   //   console.log("Edit Data 👉", row);
//   //   // 👉 yaha form me bhej sakte ho
//   // };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "pending":
//         return "warning";
//       case "approved":
//         return "success";
//       case "rejected":
//         return "error";
//       default:
//         return "default";
//     }
//   };


//   const handlApproveOrReject = async (leave) => {
//     const result = await Swal.fire({
//       title: "Update Leave Status",
//       text: "Please select an action to proceed:",
//       icon: "question",
//       input: "select",
//       inputOptions: {
//         approved: "Approve",
//         rejected: "Reject",
//         cancelled: "Cancel Leave", // "cancelled" status ke liye
//       },
//       inputPlaceholder: "Select Status",
//       showCancelButton: true,
//       confirmButtonText: "Submit",
//       cancelButtonText: "Close",
//       confirmButtonColor: "#007bff",
//       inputValidator: (value) => {
//         if (!value) {
//           return "You need to select a status!";
//         }
//       },
//     });

//     // Agar user ne Cancel/Close click kiya ya modal ke bahar click kiya
//     if (!result.isConfirmed || !result.value) {
//       return;
//     }

//     // result.value me selected status ('approved', 'rejected', ya 'cancelled') aayega
//     const payload = {
//       status: result.value,
//     };

//     try {
//       const response = await configServ.updateLeaveStatus(leave.id, payload);

//       if (response.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: `Leave ${payload.status} successfully.`,
//         });

//         fetchLeaveData(page, rowsPerPage);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Failed",
//           text: "Failed to update leave status.",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: error?.response?.data?.message || "Something went wrong!",
//       });
//     }
//   };

//   return (
//     <>
//       <Box sx={{ width: "100%", p: 2 }}>
//         {loading ? (
//           <Box
//             sx={{ display: "flex", justifyContent: "center", minHeight: 300 }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : leaveData.length === 0 ? (
//           <Paper sx={{ p: 5, textAlign: "center" }}>
//             <Typography>No Leave Data Found</Typography>
//           </Paper>
//         ) : (
//           <>
//             {/* ✅ TABLE */}
//             <TableContainer component={Paper}>
//               <Table>
//                 <TableHead sx={{ backgroundColor: "#1976d2" }}>
//                   <TableRow>
//                     <TableCell sx={{ color: "#fff" }}>S.No</TableCell>
//                     <TableCell sx={{ color: "#fff" }}>Emp Name</TableCell>
//                     <TableCell sx={{ color: "#fff" }}>Leave Type</TableCell>
//                     <TableCell sx={{ color: "#fff" }}>Reason</TableCell>
//                     <TableCell sx={{ color: "#fff" }}>Duration</TableCell>
//                     <TableCell sx={{ color: "#fff" }}>Days</TableCell>
//                     <TableCell sx={{ color: "#fff" }}>Status</TableCell>
//                     <TableCell sx={{ color: "#fff" }}>Action</TableCell>
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {leaveData.map((row, index) => (
//                     <TableRow key={row.id}>
//                       <TableCell>{page * rowsPerPage + index + 1}</TableCell>

//                       <TableCell>{row.employee_name || "-"}</TableCell>

//                       <TableCell>{row.leave_name || "-"}</TableCell>

//                       <TableCell>
//                         <Tooltip title={row.reason || "-"}>
//                           <span>{truncateText(row.reason, 15)}</span>
//                         </Tooltip>
//                       </TableCell>

//                       <TableCell>
//                         {row.from_date || "-"} <br />
//                         <small>to</small> <br />
//                         {row.to_date || "-"}
//                       </TableCell>

//                       <TableCell>{row.total_days || 0}</TableCell>

//                       <TableCell>
//                         <Chip
//                           label={row.status?.toUpperCase()}
//                           color={getStatusColor(row.status)}
//                           size="small"
//                         />
//                       </TableCell>

//                       <TableCell>
//                         <IconButton onClick={() => handleOpen(row)}>
//                           <VisibilityIcon />
//                         </IconButton>

//                         <IconButton
//                           onClick={() => handleEdit(row)}
//                           color="secondary"
//                         >
//                           <EditIcon />
//                         </IconButton>

//                         <IconButton
//                           onClick={() => handlApproveOrReject(row)}
//                           color="secondary"
//                         >
//                           <OfflinePinIcon />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* ✅ Pagination */}
//             <TablePagination
//               component="div"
//               count={total}
//               page={page}
//               onPageChange={(e, newPage) => setPage(newPage)}
//               rowsPerPage={rowsPerPage}
//               onRowsPerPageChange={(e) => {
//                 setRowsPerPage(parseInt(e.target.value, 10));
//                 setPage(0);
//               }}
//             />
//           </>
//         )}

//         {/* ✅ Dialog */}
//         <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
//           <DialogTitle>Leave Details</DialogTitle>
//           <DialogContent>
//             {selectedLeave && (
//               <>
//                 <Typography>
//                   <b>Employee:</b> {selectedLeave.employee_name || "-"}
//                 </Typography>
//                 <Typography>
//                   <b>Leave Type:</b> {selectedLeave.leave_name}
//                 </Typography>
//                 <Typography>
//                   <b>Holiday Type:</b> {selectedLeave.holiday_title || "-"}
//                 </Typography>

//                 <Typography>
//                   <b>Reason:</b> {selectedLeave.reason || "-"}
//                 </Typography>
//                 <Typography>
//                   <b>From:</b> {selectedLeave.from_date}
//                 </Typography>
//                 <Typography>
//                   <b>To:</b> {selectedLeave.to_date}
//                 </Typography>
//                 <Typography>
//                   <b>Days:</b> {selectedLeave.total_days}
//                 </Typography>
//                 <Typography>
//                   <b>Status:</b> {selectedLeave.status}
//                 </Typography>
//               </>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpen(false)}>Close</Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </>
//   );
// };

// export default LeaveTable;




import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Chip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TablePagination,
  CircularProgress,
} from "@mui/material";
import Swal from "sweetalert2";

import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import OfflinePinIcon from "@mui/icons-material/OfflinePin";
import configServ from "../services/config";
import { useSelector } from "react-redux";

const LeaveTable = ({ handleEdit, ischange }) => {
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [open, setOpen] = useState(false);
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { company_id, is_admin, is_super, permissions } = useSelector(
    (state) => state.GlobalVariables
  );

  // ✅ Admin view detection
  const isAdminView = !!(is_super || is_admin || permissions?.includes(80));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const truncateText = (text, limit = 20) => {
    if (!text) return "-";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const fetchLeaveData = async (currentPage, limit) => {
    setLoading(true);
    try {
      // ✅ Admin view me employee_id BILKUL mat bhejo
      const params = {
        company_id: company_id,
        page: currentPage + 1,
        per_page: limit,
        isAdmin: isAdminView,
      };

      const response = await configServ.getLeaves(params);

      if (response.status === 200) {
        setLeaveData(response.data.data || []);
        setTotal(response.data.total || 0);
      } else {
        setLeaveData([]);
        setTotal(0);
      }
    } catch (error) {
      console.log(error);
      setLeaveData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveData(page, rowsPerPage);
  }, [page, rowsPerPage, ischange]);

  const handleOpen = (leave) => {
    setSelectedLeave(leave);
    setOpen(true);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return "warning";
      case "approved":
        return "success";
      case "rejected":
        return "error";
      default:
        return "default";
    }
  };

  const handlApproveOrReject = async (leave) => {
    const result = await Swal.fire({
      title: "Update Leave Status",
      text: "Please select an action to proceed:",
      icon: "question",
      input: "select",
      inputOptions: {
        approved: "Approve",
        rejected: "Reject",
        cancelled: "Cancel Leave",
      },
      inputPlaceholder: "Select Status",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Close",
      confirmButtonColor: "#007bff",
      inputValidator: (value) => {
        if (!value) return "You need to select a status!";
      },
    });

    if (!result.isConfirmed || !result.value) return;

    const payload = { status: result.value };

    try {
      const response = await configServ.updateLeaveStatus(leave.id, payload);

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `Leave ${payload.status} successfully.`,
        });
        fetchLeaveData(page, rowsPerPage);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Failed to update leave status.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong!",
      });
    }
  };

  return (
    <>
      <Box sx={{ width: "100%", p: 2 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", minHeight: 300 }}>
            <CircularProgress />
          </Box>
        ) : leaveData.length === 0 ? (
          <Paper sx={{ p: 5, textAlign: "center" }}>
            <Typography>No Leave Data Found</Typography>
          </Paper>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table>
                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                  <TableRow>
                    <TableCell sx={{ color: "#fff" }}>S.No</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Emp Name</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Leave Type</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Reason</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Duration</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Days</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {leaveData.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>{row.employee_name || "-"}</TableCell>
                      <TableCell>{row.leave_name || "-"}</TableCell>
                      <TableCell>
                        <Tooltip title={row.reason || "-"}>
                          <span>{truncateText(row.reason, 15)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        {row.from_date || "-"} <br />
                        <small>to</small> <br />
                        {row.to_date || "-"}
                      </TableCell>
                      <TableCell>{row.total_days || 0}</TableCell>
                      <TableCell>
                        <Chip
                          label={row.status?.toUpperCase()}
                          color={getStatusColor(row.status)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleOpen(row)}>
                          <VisibilityIcon />
                        </IconButton>

                        <IconButton
                          onClick={() => handleEdit(row)}
                          color="secondary"
                        >
                          <EditIcon />
                        </IconButton>

                        <IconButton
                          onClick={() => handlApproveOrReject(row)}
                          color="secondary"
                        >
                          <OfflinePinIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={total}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />
          </>
        )}

        <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
          <DialogTitle>Leave Details</DialogTitle>
          <DialogContent>
            {selectedLeave && (
              <>
                <Typography>
                  <b>Employee:</b> {selectedLeave.employee_name || "-"}
                </Typography>
                <Typography>
                  <b>Leave Type:</b> {selectedLeave.leave_name}
                </Typography>
                <Typography>
                  <b>Holiday Type:</b> {selectedLeave.holiday_title || "-"}
                </Typography>
                <Typography>
                  <b>Reason:</b> {selectedLeave.reason || "-"}
                </Typography>
                <Typography>
                  <b>From:</b> {selectedLeave.from_date}
                </Typography>
                <Typography>
                  <b>To:</b> {selectedLeave.to_date}
                </Typography>
                <Typography>
                  <b>Days:</b> {selectedLeave.total_days}
                </Typography>
                <Typography>
                  <b>Status:</b> {selectedLeave.status}
                </Typography>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default LeaveTable;